import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeStatusCommand extends BaseCommand {
  CommandName = "ChangeStatus";
  Command: { Value: number };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
